var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tile is-parent",
    staticStyle: {
      "flex-grow": "unset"
    }
  }, [_c('div', {
    staticClass: "tile is-child"
  }, [_c('article', {
    staticClass: "panel",
    class: {
      'ouro-especial': _vm.ouroEspecial,
      'ouro': _vm.ouro,
      'prata': _vm.prata,
      'bronze': _vm.bronze
    }
  }, [_c('p', {
    staticClass: "panel-heading",
    domProps: {
      "textContent": _vm._s(_vm.medalha)
    }
  }), _vm._l(_vm.premiados, function (aluno, i) {
    return _c('span', {
      key: i,
      staticClass: "panel-block"
    }, [_c('span', {
      staticClass: "is-flex-grow-1"
    }, [_vm._v(_vm._s(aluno.nome))]), aluno.nivelRioplatense ? _c('b-tag', {
      class: {
        'is-warning': !aluno.isSuplenteRioplatense
      }
    }, [_vm._v(_vm._s(aluno.isSuplenteRioplatense ? aluno.isSuplenteRioplatense + '° Suplente' : 'Equipe') + " Nível " + _vm._s(aluno.nivelRioplatense))]) : _vm._e()], 1);
  })], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };